module.exports = __webpack_public_path__ + "static/work4-6750ff74f3e2ecc243f6b90350a4b47c.jpg";